import dayjs from "dayjs";

import { QuizQuestionProps } from "@/pages/quiz/context/types";
import { HelpYouLoseSvg } from "@/pages/quiz/base/questions/banners/common/helpYouLoseSvg";
import { useQuizContext } from "@/pages/quiz/context";
import { Button } from "@/pages/quiz/15000/components/Button";

const WeCanHelpYouLose = ({
  setQuestionAnswer,
}: QuizQuestionProps<boolean>) => {
  const { answers } = useQuizContext();

  const weightQuestion = Object.values(answers).find(
    (answer) =>
      answer.blockName === "height-weight-input-fields" ||
      answer.blockName === "height-weight-input-fields-with-bmi"
  )?.value as {
    weight: string;
  };

  const startWeight = Number(weightQuestion?.weight || 0);

  const weigthAfterThreeMonths = Math.round(startWeight * 0.18);

  const weight = {
    first: startWeight * 0.95,
    second: startWeight * 0.9,
    third: startWeight * 0.86,
    fourth: startWeight * 0.82,
    fifth: startWeight * 0.8,
  };

  return (
    <>
      <div className="text-4xl mb-6 text-new-design-gray-500 font-medium whitespace-normal break-keep hyphens-none">
        We can help you lose up to <b>{weigthAfterThreeMonths} pounds </b>by{" "}
        <b>{dayjs(new Date()).add(3, "month").format("MM/DD/YYYY")}!</b>
      </div>
      <div className="mt-4 flex justify-center">
        <HelpYouLoseSvg weight={weight} />
      </div>

      <Button onClick={() => setQuestionAnswer(true)} />
    </>
  );
};

export { WeCanHelpYouLose };
